<template>

          <div>
            <l-map id="mapCommunities" ref="map" @focus="handleFocus"  @focusout="handleFocusOut" :max-zoom="6" :min-zoom="1" :options="{scrollWheelZoom:scrollWheelZoom}" :zoom="zoom"  :zoomAnimation="zoomAnimation" :fadeAnimation="fadeAnimation" :markerZoomAnimation="markerZoomAnimation" style="border-radius: 5px 5px 0 0">
            <l-tile-layer
            v-for="tileProvider in tileProviders"
            :key="tileProvider.name"
            :name="tileProvider.name"
            :visible="tileProvider.visible"
            :url="tileProvider.url"
            :attributionControl="false"
            :leafletAttributionControl="false"
            layer-type="base"
            />
            <l-marker v-for="location in activeAirports" v-bind:key="location.airportID" :lat-lng="location.airportCoordinates">
                <l-icon
                  :title="location.airportName"
                  icon-url="/img/Pointer.svg"
                />
                <l-tooltip
                  :content="'✈ ' + location.airportName + ' (' + location.airportIATA + ')'"
                />
            </l-marker>
        </l-map>
        <div class="panel panel-default" style="border-radius: 0 0 5px 5px">
        <div class="panel-body">
          <div class="form-group">
            <center>
                <p>{{(this.translation["2157"])}}</p>
                <span class="badge badge-info-fs" v-if="activeAirports.length == 0" style="font-size: 14px;margin-bottom: 5px;font-style: italic;">{{(this.translation["2161"])}}</span>
            <span class="badge badge-info-fs" style="font-size: 14px;margin-bottom: 5px;" v-for="(item, key, index) in activeAirports" :key="index" :style="{ backgroundColor: hoveredCommunity === item.airportCommunity ? '#dc3545' : '', color: hoveredCommunity === item.airportCommunity ? 'white' : '' }">
                    {{item.airportName + ' (' + item.airportIATA + ')' }} <span @mouseover="hoveredCommunity = item.airportCommunity" @mouseleave="hoveredCommunity = null"  @click="removeCommunity(item.airportCommunity)" style="cursor: pointer;" v-if="editable">✖</span>
            </span><div v-if="editable"><br></div>
            <span v-if="editable">{{(this.translation["2158"])}}<br><br></span> 

            <div v-if="editable" class="input-group" style="margin-top:5px;">
            <select id="airportDropdown" v-model="selectedCommunity" class="form-control" style="margin-top: 1px;">
                <option value="" disabled>{{(this.translation["2159"])}}</option>
                <option v-for="(item, index) in filteredAirports" :key="index" :value="item.airportCommunity">
                  {{item.airportName + ' (' + item.airportIATA + ')' }}
                </option>
            </select>
            <div class="input-group-btn">
                <button @click="addCommunity" class="btn btn-info">{{(this.translation["2162"])}}</button>
            </div>
            </div>
            </center>
          </div>
          </div></div>
          
        </div>
  </template>
  
  <script>
    import "leaflet/dist/leaflet.css";
    import {LMap, LTileLayer, LControlLayers, LPolyline, LPolygon, LCircle, LCircleMarker, LMarker, LIcon, LGeoJson, LPopup, LTooltip} from 'vue2-leaflet';
  export default {
    props:['trans'],
    data() {
      return {
        selectedCommunity: '',
        airports: airports,
        communities: communities,
        CompID: CompID,
        handler: handler,
        userclass: userclass,
        hoveredCommunity: null,
        translation: this.trans,
        tileProviders: [
        {
          name: 'OSM',
          visible: true,
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', //https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png https://tile.openstreetmap.org/{z}/{x}/{y}.png
        }
        ],
        zoom: 2,
        zoomAnimation: true,
        fadeAnimation: false,
        markerZoomAnimation: false,
        center: [28,-35],
        scrollWheelZoom: false,
        editable: false,
      };
    },
    components: {
      LMap,
      LTileLayer,
      LControlLayers,
      LPolyline,
      LPolygon,
      LCircle,
      LMarker,
      LGeoJson,
      LPopup,
      LTooltip,
      LCircleMarker,
      LIcon
    },
    computed: {
        filteredAirports() {
            return this.airports.filter(item => item.airportCommunity !== null && !this.communities.includes(item.airportCommunity));
        },
        activeAirports() {
            return this.airports.filter(item => this.communities.includes(item.airportCommunity));
        }
    },
    beforeMount: function () {
          if(this.handler != 1 && [2021, 2022, 2023].includes(this.userclass) ) {
            this.editable = true;
          }
    },
    mounted: function () {
      if(this.activeAirports.length > 0) {
          this.fitMapToMarkers();
      } else {
          //this.$refs.map.panTo(new L.LatLng(28,-35));
          this.$refs.map.fitBounds([[41.979444, -87.904444],[60.317222, 24.963333],[-33.969444, 18.597222]], { padding: [50, 50] });
      };
    },
    watch: {
        activeAirports: {
            handler() {
            this.fitMapToMarkers();
            },
            deep: true
        }
    },
    methods: {
        fitMapToMarkers() {
            if (this.activeAirports.length === 0) return;

            const bounds = this.activeAirports.map(a => a.airportCoordinates);
            this.$nextTick(() => {
            this.$refs.map.fitBounds(bounds, { padding: [50, 50] });
            });
        },
        addCommunity() {
          self = this;
          if (this.selectedCommunity) {
              $.post('t110/f004', {
                _token: $('meta[name=csrf-token]').attr('content'),
                CompID: this.CompID,
                newCommunities: [this.selectedCommunity],
              })
              .fail(function(data) {
                console.log('error in function updateCommunity');
              })
              .done(function(data) {
                self.communities.push(parseInt(self.selectedCommunity));
                self.selectedCommunity = '';
              });
          } else {
            alert(self.translation["2160"]);
          }
        },
        removeCommunity(community) {
          self = this;
          $.post('t110/f004a', {
              _token: $('meta[name=csrf-token]').attr('content'),
              CompID: this.CompID,
              removeCommunities: [community],
          })
          .fail(function(data) {
              console.log('error in function removeCommunity');
          })
          .done(function(data) {
              const index = self.communities.indexOf(parseInt(community));
              if (index > -1) { // only splice array when item is found
                  self.communities.splice(index, 1); // 2nd parameter means remove one item only
              }
          });

        },
        handleFocus() {
        },
        handleFocusOut() {
        }
    }
  };
  </script>
  
  <style>
  #mapCommunities {
    background-color: #fff;
    height:300px;
    width:100%;
    border-radius: 5px;
    box-shadow: 0 -10px 10px -10px rgba(19, 29, 41, 0.05),
            10px 0 10px -10px rgba(19, 29, 41, 0.05),
            -10px 0 10px -10px rgba(19, 29, 41, 0.05);
  }

  .badge-info-fs {
    transition: color 0.2s, padding 0.2s, background 0.2s;
  }
  
  .leaflet-tile-pane {
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
    opacity: 0.6;
  }
  
  .leaflet-control-attribution {
    display: none;
  }
  
  .leaflet-tooltip {
      background-color: #ffd832;
      color: #4b4b4b;
      font-weight: 500;
      border: 0px;
      box-shadow: none;
      border-radius: 2.5rem;
      padding-left: 10px;
      padding-right: 10px;
      font-size: 13px;
      margin-top:-50%;
      font-family: "Telegraf", sans-serif;
  }
  .leaflet-tooltip-top:before, 
  .leaflet-tooltip-bottom:before, 
  .leaflet-tooltip-left:before, 
  .leaflet-tooltip-right:before {
      border: none !important;
  }
  
  .leaflet-bar a {
    background-color: #e4e4e4;
    color: #7e7e7e;
  }
  </style>
  